const questions = [
  {
    label:
      'Conte uma história que você usou o pensamento lógico para resolver um desafio na sua vida. Qual desafio você resolveu?  O que você fez? Como foi?',
    answers: [
      {
        label: 'Precisa desenvolver',
        value: 0
      },
      {
        label: 'Neutro',
        value: 12
      },
      {
        label: 'É uma força',
        value: 18
      }
    ],
    layout: 'inline'
  },
  {
    label:
      'Conte um momento em que você viveu o seu maior desafio de aprendizado, na sala de aula ou no trabalho. O que aprendeu? O que você fez? Como foi? ',
    answers: [
      {
        label: 'Precisa desenvolver',
        value: 0
      },
      {
        label: 'Neutro',
        value: 6
      },
      {
        label: 'É uma força',
        value: 12
      }
    ],
    layout: 'inline'
  },
  {
    label:
      'Conte uma história que você conseguiu se antecipar e resolver um problema, seja em sala de aula ou no seu trabalho. O que você fez? Como foi?',
    answers: [
      {
        label: 'Precisa desenvolver',
        value: 0
      },
      {
        label: 'Neutro',
        value: 12
      },
      {
        label: 'É uma força',
        value: 18
      }
    ],
    layout: 'inline'
  },
  {
    label:
      'Conte uma história que você queria muito realizar um projeto na sua vida, mas teve dificuldade de manter o foco e o comprometimento. O que você fez? Como foi?',
    answers: [
      {
        label: 'Precisa desenvolver',
        value: 0
      },
      {
        label: 'Neutro',
        value: 6
      },
      {
        label: 'É uma força',
        value: 12
      }
    ],
    layout: 'inline'
  },
  {
    label:
      'Você acabou de receber uma oportunidade de estágio, mas a vaga é presencial e a empresa fica bem distante da sua casa. Você…',
    answers: [
      {
        label:
          'Aceita, mas fica atento(a) nas primeiras semanas de estágio, se terá possibilidade de trabalho remoto',
        value: 8
      },
      {
        label:
          'Aceita, mas confirma se é possível estagiar remotamente, afinal assim você vai conseguir produzir mais se evitar um desgaste com um longo trajeto.',
        value: 12
      },
      {
        label:
          'Confirma se precisa estagiar presencialmente, em caso positivo, aceita sem nenhum problema.',
        value: 0
      }
    ]
  },
  {
    label:
      'Você está na reta final do semestre e precisa entregar o trabalho de conclusão do curso. Restam 4 horas para a entrega do trabalho e você está revisando os 20 tópicos, por enquanto está tudo certo, mas percebe que você não aprendeu totalmente o tópico 18. Você…',
    answers: [
      {
        label:
          'Continuaria com a revisão, ponto por ponto, para garantir uma boa nota do trabalho.',
        value: 4
      },
      {
        label:
          'Estudaria o tópico 18 no mesmo momento, até entender totalmente o conteúdo.',
        value: 8
      },
      {
        label:
          'Estudaria o tópico 18 logo após a entrega do trabalho, para não atrapalhar a revisão do trabalho e ter tempo hábil para revisar os tópicos, 19 e 20.',
        value: 0
      }
    ]
  },
  {
    label:
      'É uma terça-feira no Instituto Eurofarma. Você está no final da aula e finalizando a entrega de um trabalho em grupo, mas um integrante da sua equipe que no início estava motivado, começa a ficar irritado com você e reclama que não teve espaço para expor ideias. Então você…',
    answers: [
      {
        label:
          'Fala com calma e explica que naquele momento não será possível ajustar o trabalho, faltando 5 minutos para finalizar o prazo de entrega.',
        value: 12
      },
      {
        label:
          'Com empatia tenta acalmar o colega e pede ajuda da líder da sua equipe para resolver o problema, afinal, ela já passou por isso outras vezes e sabe bem como lidar nessas situações.',
        value: 0
      },
      {
        label:
          'Buscaria ouvir e entender a reclamação para tentar solucionar o problema do colega',
        value: 8
      }
    ]
  },
  {
    label:
      'Você se inscreveu em uma palestra de marketing pessoal indicada por seu amigo.  Você teve um dia estressante e está quase chegando na sua casa, mas de repente, recebe uma notificação no celular, com a informação que a palestra iniciará em 30 minutos. Então você:',
    answers: [
      {
        label:
          'Liga para o seu amigo, avisando a sua ausência e pede que ele grave a palestra pra você.',
        value: 4
      },
      {
        label:
          'Muda a rota e vai assistir a palestra, mesmo que não consiga ter 100% de concentração.',
        value: 8
      },
      {
        label:
          'Pensando nas melhores práticas de saúde mental, você vai para casa e na primeira oportunidade conversa com o seu amigo e estuda todo o conteúdo da palestra.',
        value: 0
      }
    ]
  }
];

export default questions;
